import React from 'react';

import './page-header.scss';
import TypeaheadAccountSelector from '../../_global/typeahead-account-selector/typeahead-account-selector';
import HeaderAccountSelector from '../../header/header-account-selector';
import { Button } from '@ampol/design-system';
import { useSelector  } from 'react-redux';

interface PageHeaderProps {
  title?,
  showAccountSelector?,
  showHeaderAccountSelector?,
  allowCashAccountsOnly?,
  accounts?,
  isAccountsFlatList?,
  onAccountSelected?,
  selectedAccountNumber?,
  showButton?,
  buttonLabel?,
  onButtonClick?,
  isButtonInactive?,
}

/**
 * Consistant Header for all pages

 * @returns JSX Element
 */
const PageHeader = ({
  title,
  showAccountSelector,
  showHeaderAccountSelector,
  allowCashAccountsOnly,
  accounts,
  isAccountsFlatList,
  onAccountSelected,
  selectedAccountNumber,
  showButton,
  buttonLabel,
  onButtonClick,
  isButtonInactive,
}: PageHeaderProps) => {

  const allAccountsIsLoading = useSelector((state: any) => state.accountsStore.isAllAccountsLoading);

  return <>
    <div className="page-header">
      {title && <h3 className="page-header__title">{title}</h3>}
      {showHeaderAccountSelector &&
        <HeaderAccountSelector 
          allowCashAccountsOnly={allowCashAccountsOnly}
        />
      }
      {showAccountSelector &&
        <TypeaheadAccountSelector
          accounts={accounts}
          onSelect={onAccountSelected}
          selectedAccountItem={selectedAccountNumber}
          isAccountsFlatList={isAccountsFlatList}
        />
      }
      {showButton &&
        <Button
          color="blue"
          label={buttonLabel}
          onClick={() => !allAccountsIsLoading && onButtonClick()}
          variant="primary"
          className="page-header__button"
          loading={allAccountsIsLoading}
          inactive={isButtonInactive || allAccountsIsLoading}
        />
      }
    </div>
  </>;
};

export default PageHeader;
